<div class="modal-header">
        <h4 class="modal-title fw-bold">
            <span *ngIf="attributeId" jhiTranslate="lot-attribute-modal.edit.header"></span>
            <span *ngIf="!attributeId" jhiTranslate="lot-attribute-modal.create.header"></span>
        </h4>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
                (click)="clear()">
        </button>
</div>
<div class="modal-body">
    <form name="form" #f="ngForm">
        <div class="mb-3 row required">
            <label for="dropdownvariable" class="col-sm-3 col-form-label fw-bold" jhiTranslate="lot-attribute-modal.variable">Variable</label>
            <div class="col-sm-9">
                <jhi-variable-select name="dropdownvariable" id="dropdownvariable"
                                     (onVariableSelectedChange)="selectVariable($event)"
                                     [value]="variable?.id"
                                     [variableTypeIds]="[attributeTypeId]"
                                     [disabled]="attributeId !== null && attributeId !== undefined">
                </jhi-variable-select>
            </div>
        </div>
        <div class="mb-3 row required" [ngSwitch]="variable?.scale?.dataType?.name">
            <label for="variablevalue" class="col-sm-3 col-form-label fw-bold" jhiTranslate="lot-attribute-modal.value">Value</label>
            <div class="col-sm-9" *ngSwitchCase="DataType.CATEGORICAL">
                <select class="form-select" name="variablevalue" id="variablevalue" [(ngModel)]="value" #variablevalue="ngModel" required>
                    <option *ngFor="let category of variable.scale.validValues.categories"
                            [title]="category.description"
                            [value]="category.name">
                        <label>{{category.name}}</label>
                    </option>
                </select>
            </div>
            <div class="col-sm-9" *ngSwitchCase="DataType.DATE">
                <div class="input-group">
                    <input class="form-control" name="variablevalue" id="variablevalue"
                           [placeholder]="'global.date.placeholder' | translate"
                           [(ngModel)]="dateValue"
                           (dateSelect)="value = dateHelperService.convertNgbDateToString($event)"
                           ngbDatepicker #valuedate="ngbDatepicker" required />
                    <button class="btn btn-outline-secondary calendar" (click)="valuedate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
            <div class="col-sm-9" *ngSwitchCase="DataType.NUMERIC" >
                <input type="number" class="form-control" name="variablevalue" id="variablevalue" [(ngModel)]="value" #variablevalue="ngModel" maxlength="255"
                       [title]="getNumericOutOfRangeWarning()"
                       [class.accepted-value]="isNumericOutOfRange()" />
            </div>
            <div class="col-sm-9" *ngSwitchDefault >
                <textarea class="form-control" rows="3" name="variablevalue" id="variablevalue" [(ngModel)]="value" #variablevalue="ngModel" jhi-forbiddenCharactersValidator maxlength="5000"></textarea>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="attributedate" class="col-sm-3 col-form-label fw-bold" jhiTranslate="lot-attribute-modal.date">Date</label>
            <div class="col-sm-9">
                <div class="input-group">
                    <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="date"
                           ngbDatepicker #attributedate="ngbDatepicker" id="attributedate" name="date" required/>
                    <button class="btn btn-outline-secondary calendar" (click)="attributedate.toggle()" type="button"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
        <div class="mb-3 row required">
            <label for="dropdownLocations" class="col-sm-3 col-form-label fw-bold" jhiTranslate="lot-attribute-modal.location">Location</label>
            <div class="col-sm-9">
                <jhi-locations-select [(value)]="locationId" [showFilterOptions]="false" [clearable]="false"></jhi-locations-select>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="clear()">
        <span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
    </button>
    <button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
        <span *ngIf="isLoading" class="throbber throbber-btn"></span>
        <span class="fa fa-save"></span>&nbsp;
        <span *ngIf="attributeId" jhiTranslate="update"></span>
        <span *ngIf="!attributeId" jhiTranslate="create"></span>
    </button>
</div>
